import React, { useState } from 'react';
import { ContainerFullWidth } from 'components/layouts/ContainerFullWidth';
import { IconLabel } from 'components/atoms/Texts/IconLabel';
import { SearchInput } from 'components/atoms/Inputs/SearchInput';
import {
  CSVCommandesType,
  CommandeDef
} from '../../../types/commande/commande.def';
import { TableData } from '../Table/TableData';
import { TableDataLineCommandes } from '../Table/TableData/TableDataLineCommandes';
import { MobileTabLineCommandes } from 'components/molecules/Table/MobileTabLine/MobileTabLineCommandes';
import { IS_PROF } from '../../../helpers/user/authorization';
import { useMediaQuery } from 'hooks/useMediaQuery';
import { CommandeErrorBlock } from 'components/molecules/Blocks/CommandeErrorBlock';
import { ID } from '../../../types/typeDef';
import { DownloadCSVButton } from 'components/atoms/Buttons/DownloadCSVButton';
import { FeatureContainer } from 'components/molecules/Containers/FeatureContainer';
import { WarningHeaderBlock } from 'components/molecules/Blocks/WarningHeaderBlock';

interface CommandesTableViewProps {
  ExternalUserName?: string;
  commandes: Array<CommandeDef>;
  csvCommandes: CSVCommandesType;
  csvCommandesName?: string;
  toCommandeSinglePage: (id: ID) => void;
  toCommandeUpdatePage: (id: ID) => void;
}

const CommandesTableView = ({
  ExternalUserName,
  commandes,
  csvCommandes,
  csvCommandesName = 'PERSONNELLES',
  toCommandeSinglePage,
  toCommandeUpdatePage
}: CommandesTableViewProps): JSX.Element => {
  const [haveWarningOrder, setWarningOrder] = useState(false);
  const [search, setSearch] = useState('');
  const isDesktop = useMediaQuery('desktop');

  if (!commandes || commandes.length === 0)
    return (
      <CommandeErrorBlock
        ExternalUserName={ExternalUserName && ExternalUserName}
      />
    );
  return (
    <ContainerFullWidth>
      {ExternalUserName && (
        <FeatureContainer>
          <p>Carnet de Commande de {ExternalUserName}</p>
          {haveWarningOrder && <WarningHeaderBlock variant="MesCommandes" />}
        </FeatureContainer>
      )}
      <div>
        <IconLabel
          icon="Search"
          label={
            !isDesktop
              ? 'Rechercher une commande | (N° de commande / Nom Client)'
              : 'Rechercher une commande'
          }
        />
        <SearchInput
          value={search}
          onChange={e => setSearch(e.target.value)}
          placeHolder="N° de commande..."
        />
      </div>
      <span>{`* Les ${
        isDesktop ? 'cartes grises' : 'lignes en gris'
      } représentent les commandes e-boutique`}</span>
      {!isDesktop ? (
        <>
          <TableData
            tabLabels={[
              'Numéro de commande',
              'Date',
              'Nom Client',
              'Client Pro',
              'Total TTC (port inclus + ONG)',
              'Statut de paiement',
              'Statut livraison',
              'Participation ONG',
              'Détails',
              IS_PROF && 'Modifier'
            ]}
          >
            {commandes
              .filter(
                commande =>
                  commande.status !== 'A_FINALISER' &&
                  (commande.numerocommande.includes(search) ||
                    commande.client.nom
                      .toLowerCase()
                      .includes(search.toLowerCase()) ||
                    commande.client.prenom
                      .toLowerCase()
                      .includes(search.toLowerCase()))
              )
              .map(commande => {
                if (commande.orderNeedToBeReminded && !haveWarningOrder)
                  setWarningOrder(true);
                return (
                  <TableDataLineCommandes
                    variant={
                      commande.orderNeedToBeReminded ? 'warning' : 'default'
                    }
                    key={commande.id}
                    commande={commande}
                    toCommandeSinglePage={() =>
                      toCommandeSinglePage(commande.id)
                    }
                    toCommandeUpdatePage={() =>
                      toCommandeUpdatePage(commande.id)
                    }
                  />
                );
              })}
          </TableData>

          <DownloadCSVButton
            fileName={'COMMANDES-' + csvCommandesName}
            file={csvCommandes}
            title="Téléchargez mes commandes en .CSV"
            toastMessage="Liste des commandes téléchargée 📔"
          />
        </>
      ) : (
        <div>
          {commandes
            .filter(
              commande =>
                commande.status !== 'A_FINALISER' &&
                (commande.numerocommande.includes(search) ||
                  commande.client.nom.includes(search) ||
                  commande.client.prenom.includes(search))
            )
            .map(commande => {
              if (commande.orderNeedToBeReminded && !haveWarningOrder)
                setWarningOrder(true);

              return (
                <MobileTabLineCommandes
                  key={commande.id}
                  commande={commande}
                  toCommandeSinglePage={() => toCommandeSinglePage(commande.id)}
                  toCommandeUpdatePage={() => toCommandeUpdatePage(commande.id)}
                  variant={
                    commande.orderNeedToBeReminded ? 'warning' : 'default'
                  }
                />
              );
            })}
        </div>
      )}
    </ContainerFullWidth>
  );
};

export default CommandesTableView;
